import React from 'react';
import { motion } from 'framer-motion';
export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-gray-900 text-white py-16" data-id="element-425">
      <div className="container mx-auto px-4" data-id="element-426">
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-427">
          <motion.div className="mb-8 md:mb-0" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} viewport={{
          once: true
        }} data-id="element-428">
            <h2 className="text-3xl font-black tracking-tight text-glow" data-id="element-429">
              BODY-HACK.CZ
            </h2>
            <p className="text-gray-400 mt-3 text-lg" data-id="element-430">
              Transformuj své tělo. Změň svou mysl. Ovládni sebe sama.
            </p>
          </motion.div>
          <motion.div className="text-gray-400 text-base" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} viewport={{
          once: true
        }} data-id="element-431">
            <p data-id="element-432">© {currentYear} Body-Hack.cz. Všechna práva vyhrazena.</p>
          </motion.div>
        </div>
        <motion.div className="border-t border-gray-800 mt-12 pt-12 text-center text-gray-500 text-sm" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} viewport={{
        once: true
      }} data-id="element-433">
          <p className="max-w-3xl mx-auto" data-id="element-434">
            Výsledky se mohou lišit podle individuálního úsilí, konzistence a
            genetických předpokladů. Tréninkové plány a doplňky stravy
            nenahrazují lékařskou péči. V případě zdravotních potíží se poraďte
            s lékařem.
          </p>
        </motion.div>
      </div>
    </footer>;
};